export enum DOT_PAGINATION_VARIANTS {
    LIGHT,
    DARK,
}
